import React from 'react';
import CreateProducerPage from '../../Backoffice/CreateProducerPage/CreateProducerPage';
import RecommendationListsPage from '../RecommendationListsPage/RecommendationListsPage';
import ProducersList from '../../Backoffice/ProducerListPage/ProducersList';

const ADMIN_BACKOFFICE_SECTIONS = {
  CREATE_PRODUCER: 'createProducer',
  RECOMMENDATION_LISTS: 'recommendationLists',
  PRODUCERS_LIST: 'producersList',
};

export const useAdminBackofficePage = () => {
  const sections = [
    {
      icon: 'list',
      title: 'Productoras',
      key: ADMIN_BACKOFFICE_SECTIONS.PRODUCERS_LIST,
      component: <ProducersList />,
    },
    {
      icon: 'add',
      title: 'Crear Nueva Productora',
      key: ADMIN_BACKOFFICE_SECTIONS.CREATE_PRODUCER,
      component: <CreateProducerPage />,
    },
    {
      icon: 'list',
      title: 'Listas de Recomendación',
      key: ADMIN_BACKOFFICE_SECTIONS.RECOMMENDATION_LISTS,
      component: <RecommendationListsPage />,
    },
  ];

  return { sections };
};
